const n = (f, r, u) => !r && u ? f <= u : !u && r ? f >= r : !r || !u ? !0 : f >= r && f <= u;
export {
  n as isBetweenDateRange
};
